import { usePurgeDialog } from '~teacher/components/quizzes/PurgeDialog';
import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions';
import {
  PurgeQuizFolderMutation,
  PurgeQuizFolderOptions,
  usePurgeQuizFolder,
} from '~teacher/hook/usePurgeQuizFolder';

import { reduceUniqueIdsToObject } from '../../../../api/quiz/getQuizzes/normalize/uniqueIds';

export function usePurgeQuizItems(
  selectedQuizItem: Set<string>,
  selectNone: () => void
) {
  const purgeQuizFolderMutation = usePurgeQuizFolder([...selectedQuizItem]);

  const [
    {
      isOpen: isOpen,
      confirmAction: confirmAction,
      selectedItemCount: selectedItemCount,
    },
    dispatch,
  ] = usePurgeDialog();

  const purgeAction = createPurgeAction(purgeQuizFolderMutation.mutate, {
    onSuccess: () => {
      dispatch({ type: 'close' });
    },
    onError: (error) => {
      apiToaster([...selectedQuizItem], QuizToastActions.PURGE, error);
    },
  });

  const handleOpenPurgeDialog = () =>
    dispatch({
      type: 'open',
      payload: {
        selectedItemCount: selectedQuizItem.size,
        confirmAction: purgeAction(selectedQuizItem),
      },
    });

  const onPurgeFolder = (folderId: string) =>
    dispatch({
      type: 'open',
      payload: {
        selectedItemCount: selectedQuizItem.size,
        confirmAction: purgeAction(new Set([folderId])),
      },
    });

  const onPurgeQuiz = (quizId: string) =>
    dispatch({
      type: 'open',
      payload: {
        selectedItemCount: selectedQuizItem.size,
        confirmAction: purgeAction(new Set([quizId])),
      },
    });

  const handleClosePurgeDialog = () => {
    selectNone();
    dispatch({ type: 'close' });
  };
  return {
    isOpen,
    confirmAction,
    selectedItemCount,
    handleOpenPurgeDialog,
    onPurgeFolder,
    onPurgeQuiz,
    handleClosePurgeDialog,
  };
}

export function createPurgeAction(
  purgeQuizFolderMutation: PurgeQuizFolderMutation,
  purgeQuizFolderOptions: PurgeQuizFolderOptions
) {
  return (selectedQuizItem: Set<string>) => {
    const groupedById = reduceUniqueIdsToObject([...selectedQuizItem]);
    return () =>
      purgeQuizFolderMutation(
        {
          folderIds: [...groupedById.folder],
          quizIds: [...groupedById.quiz],
        },
        purgeQuizFolderOptions
      );
  };
}
